import { query } from "@solidjs/router";
import { MsalAuthenticatedApiGateway } from "./MsalAuthenticatedApiGateway";
import { getProjectIdAtRegistry } from "./CarbonProjectListItem";
export class AuthenticatedFunctionsApi {
    constructor(msalAuthenticationContext, queriesBaseUrl, queryScopes, systemCommandRequestsBaseUrl, systemCommandRequestsScopes) {
        Object.defineProperty(this, "queriesApiGateway", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "systemCommandRequestsApiGateway", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "invokeQuery", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (functionName, payload) => {
                const result = await this.queriesApiGateway.fetch(functionName, payload);
                return result;
            }
        });
        Object.defineProperty(this, "createSolidJsQuery", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (functionName, payload, queryName) => {
                const result = query(() => this.invokeQuery(functionName, payload), queryName);
                return result;
            }
        });
        Object.defineProperty(this, "getQueryResponseDto", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (functionName, payloadString) => {
                const result = await this.queriesApiGateway.fetchResponse(functionName, payloadString);
                return result;
            }
        });
        Object.defineProperty(this, "getSystemCommandRequestResponseDto", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (functionName, payloadString) => {
                const result = await this.systemCommandRequestsApiGateway.fetchResponse(functionName, payloadString);
                return result;
            }
        });
        Object.defineProperty(this, "marketplaceQuery", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: query(async (marketplaceId) => {
                const response = await this.invokeQuery("marketplaces/GetMarketplace", { AggregateRootId: marketplaceId });
                const result = response.AggregateRootWithPrivacyAuthorizationFilterResult.AggregateRootWithPrivacyFilterApplied;
                return result;
            }, "marketplaceById")
        });
        Object.defineProperty(this, "carbonProjectListItemsWithMetadataQuery", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: query(async () => {
                const response = await this.invokeQuery("Projects/GetCarbonProjectListItems", {});
                const responseJsonLinesArray = response.JsonLines.split("\r\n").filter(x => x.length > 0);
                const resultList = responseJsonLinesArray.map((jsonLine, index) => {
                    try {
                        return JSON.parse(jsonLine);
                    }
                    catch (err) {
                        console.error(`Failed to parse GetCarbonProjectListItems JSON line #${index}: '${jsonLine}'`, err);
                    }
                });
                const result = new Map();
                for (const carbonProjectListItemWithMetadata of resultList) {
                    const projectIdAtRegistry = getProjectIdAtRegistry(carbonProjectListItemWithMetadata);
                    if (projectIdAtRegistry) {
                        result.set(projectIdAtRegistry, carbonProjectListItemWithMetadata);
                    }
                }
                return result;
            }, "carbonProjectListItemsWithMetadata")
        });
        this.queriesApiGateway = new MsalAuthenticatedApiGateway("Queries", msalAuthenticationContext, queriesBaseUrl, queryScopes);
        this.systemCommandRequestsApiGateway = new MsalAuthenticatedApiGateway("System Command Requests", msalAuthenticationContext, systemCommandRequestsBaseUrl, systemCommandRequestsScopes);
    }
}
